import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MessageWarnComponent } from './message-warn.component';

@NgModule({
  declarations: [MessageWarnComponent],
  exports: [MessageWarnComponent],
  imports: [
    TranslateModule.forChild({
      isolate: false
    })
  ]
})
export class MessageWarnModule {}
